import { render, staticRenderFns } from "./MrWaiverList.vue?vue&type=template&id=af482692&scoped=true"
import script from "./MrWaiverList.vue?vue&type=script&lang=js"
export * from "./MrWaiverList.vue?vue&type=script&lang=js"
import style0 from "./MrWaiverList.vue?vue&type=style&index=0&id=af482692&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af482692",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af482692')) {
      api.createRecord('af482692', component.options)
    } else {
      api.reload('af482692', component.options)
    }
    module.hot.accept("./MrWaiverList.vue?vue&type=template&id=af482692&scoped=true", function () {
      api.rerender('af482692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settle/MrWaiverList.vue"
export default component.exports